module.exports = __webpack_public_path__ + "img/img-4.e4e94b2d.svg";